<template>
  <div class="section-title-container">
    <div class="title-wrapper">
      <div class="title-text">
        <h2>{{ title }}</h2>
        <p>{{ subtitle }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionTitle',
  // 接收父组件传过来的属性
  props: {
    title: {
      type: String,
      required: true, // 标题必填
      default: '核心产品'
    },
    subtitle: {
      type: String,
      default: '基于阿里云强大的基础资源'
    }
  }
}
</script>

<style scoped>
.section-title-container {
  text-align: center; /* 整体居中 */
  padding: 20px 0; /* 上下内边距，可根据需求调整 */
}

.title-wrapper {
  display: inline-flex; /* 让竖线和文字在一行 */
  align-items: center; /* 垂直居中 */
  position: relative;
}



/* 文字样式 */
.title-text h2 {
  font-size: 28px;
  font-weight: bold;
  color: #333; /* 深灰色标题 */
  margin: 0;
  line-height: 1.2;
}

.title-text p {
  font-size: 16px;
  color: #666; /* 浅灰色副标题 */
  margin: 5px 0 0 0;
}
</style>